import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { LuLock } from "react-icons/lu";
import usePermission from "../../hooks/usePermission";

// Shown instead of a page the role may not open (or when the permissions could not be loaded)
const NoAccess = () => {
  const { error, reload } = usePermission();

  return (
    <Box sx={{ minHeight: "50vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1, textAlign: "center", px: 2 }}>
      <LuLock size={40} color="var(--color-primary)" />
      <Typography variant="h5" fontWeight={700} color="var(--color-text)">
        {error ? "Your permissions could not be loaded" : "You do not have access to this page"}
      </Typography>
      <Typography variant="body2" color="var(--color-text-muted)" sx={{ maxWidth: 420 }}>
        {error ? "Check your connection and try again." : "Ask an administrator to add it to your role if you need it."}
      </Typography>
      {error ? (
        <button type="button" onClick={reload} style={{ marginTop: 8, color: "var(--color-primary)", background: "none", border: 0, cursor: "pointer", font: "inherit" }}>
          Try again
        </button>
      ) : (
        <Link to="/dashboard" style={{ marginTop: 8, color: "var(--color-primary)" }}>
          Go to my home page
        </Link>
      )}
    </Box>
  );
};

export default NoAccess;
